import { render, staticRenderFns } from "./EsclarecimentoImpugnacaoTabela.vue?vue&type=template&id=e5959d5c&"
import script from "./EsclarecimentoImpugnacaoTabela.vue?vue&type=script&lang=js&"
export * from "./EsclarecimentoImpugnacaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports